import { render, staticRenderFns } from "./Houses.vue?vue&type=template&id=79514b41&scoped=true&"
import script from "./Houses.vue?vue&type=script&lang=js&"
export * from "./Houses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79514b41",
  null
  
)

export default component.exports